import { render, staticRenderFns } from "./AllProduk.vue?vue&type=template&id=534de42c&scoped=true&"
import script from "./AllProduk.vue?vue&type=script&lang=js&"
export * from "./AllProduk.vue?vue&type=script&lang=js&"
import style0 from "./AllProduk.vue?vue&type=style&index=0&id=534de42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534de42c",
  null
  
)

export default component.exports